class WarrantyForm extends HTMLElement {
  private input: HTMLInputElement | null = null;
  private button: HTMLButtonElement | null = null;
  private quantityUpdateUnsubscriber: (() => void) | null = null;

  constructor() {
    super();
    this.input = this.querySelector('[id^="warranty-qty-"]');
    this.button = this.querySelector('[id^="change-warranty-"]');

    if (this.button) {
      this.button.addEventListener('click', this.handleSubmit.bind(this));
    }

    if (this.input) {
      this.input.addEventListener('change', this.handleInputChange.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  private handleInputChange(event: Event) {
    if (!event.target || !(event.target instanceof HTMLInputElement)) return;

    const input = event.target;
    const inputValue = parseInt(input.value);
    const min = parseInt(input.dataset.min || '0');
    const max = parseInt(input.max || '999');
    const step = parseInt(input.step || '1');

    let message = '';

    if (inputValue < min) {
      message = `Minimum quantity is ${min}`;
    } else if (inputValue > max) {
      message = `Maximum quantity is ${max}`;
    } else if (inputValue % step !== 0) {
      message = `Quantity must be in increments of ${step}`;
    }

    if (message) {
      input.setCustomValidity(message);

      //workaround to force report validity to display error message
      const valid = input.reportValidity();
      input.select();
    } else {
      input.setCustomValidity('');
      input.reportValidity();
    }

    this.toggleSubmitButton();
  }

  private handleSubmit(event: Event) {
    event.preventDefault();

    if (!this.input) return;

    const productId = this.input.getAttribute('data-product-id');
    if (!productId) return;

    const hiddenInput = document.querySelector(`#Cart-quantity-${productId}`) as HTMLInputElement;

    if (hiddenInput) {
      hiddenInput.value = this.input.value;
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  private toggleSubmitButton() {
    if (!this.input || !this.button) return;

    if (this.input.value > this.input.max) {
      this.button.setAttribute('disabled', 'disabled');
    } else {
      this.button.removeAttribute('disabled');
    }
  }
}

if (!customElements.get('warranty-form')) {
  customElements.define('warranty-form', WarrantyForm);
}
